import { render, staticRenderFns } from "./pick-month.vue?vue&type=template&id=70a707be&"
import script from "./pick-month.vue?vue&type=script&lang=js&"
export * from "./pick-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports